/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE1LDE1SDFWNS43NGg0LjZMNy42Nyw3LjYySDE1Wk0yLDE0SDE0VjguNjJINy4yOEw1LjIsNi43NEgyWiBNMTMuOTksNy44NkgxMi45OVYySDRWNS45OUgzVjFIMTMuOTlWNy44NlogTTUuOTksMy41NUgxMS4wMlY0LjU1SDUuOTlWMy41NVoiLz48L3N2Zz4=";